import { Sport } from '#src/__generated__/globalTypes.ts';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';
import { useSportContext } from '#src/contexts/sport/index.ts';

export const useShowProOnboardingBadge = () => {
  const { currentUser } = useCurrentUserContext();
  const { sport } = useSportContext();

  return (
    sport === Sport.FOOTBALL &&
    currentUser?.anyUserSportProfile?.proOnboarded === false
  );
};
